import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Intransit from "./Intransit";
import Processing from "./Processing";
import Ready_for_delivery from "./Ready_for_delivery";
import Delivered from "./Delivered";
import { useState } from "react";


const Order = () => {
  const [activeTab, setActiveTab] = useState("Intransit");

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  return (
    <div>
      <Tabs
        id="uncontrolled-tab-example"
        activeKey={activeTab}
        onSelect={handleTabSelect}
        className="mb-3 justify-content-center mt-2"
      >
        <Tab eventKey="Intransit" title="Intransit">
          {/* <LiveDelivery /> */}
        </Tab>
        <Tab eventKey="Processing" title="Processing">
          {/* <SheduledDelivery/> */}
        </Tab>
        <Tab eventKey="Ready for Delivery" title="Ready for Delivery">
          {/* <Cancelled /> */}
        </Tab>
        <Tab eventKey="Delivered" title="Delivered">
          {/* <Cancelled /> */}
          {/* <MannualPickup/> */}
        </Tab>
      </Tabs>
      {activeTab === "Intransit" && <Intransit setActiveTab={setActiveTab}/>}
      {activeTab === "Processing" && <Processing setActiveTab={setActiveTab}/>}
      {activeTab === "Ready for Delivery" && <Ready_for_delivery />}
      {activeTab === "Delivered" && <Delivered/>}
    </div>
  );
};

export default Order;
